module.exports = __webpack_public_path__ + "img/d_course.1e061069.png";